module.exports = __webpack_public_path__ + "img/ss.b3d424d1.png";